import {KpiCalculationTimeFrameDto} from '@hconnect/common/types'
import {QuickSelectSlotsToCalculationTimeFrameTypeMap, getUrlParam} from '@hconnect/common/utils'
import {useUpmPlantTimezone} from '@hconnect/upm'
import moment from 'moment-timezone'
import {useMemo} from 'react'
import {useSearchParams} from 'react-router'

import {getPlantEntryPointQuickSelectFilter} from '../utils/quickSelectFilters'

type Props = {
  key: string
  defaultTimeRange: string
  plantId: string
}

export const useAreaDefaultPlantTimeRange = ({
  key,
  defaultTimeRange,
  plantId
}: Props): {
  isLoading: boolean
  timeFrame?: KpiCalculationTimeFrameDto
} => {
  const timezone = useUpmPlantTimezone(plantId)
  const [searchParams] = useSearchParams()
  const timeRangeParam = getUrlParam(searchParams, key) ?? defaultTimeRange
  const quickSlot = timeRangeParam ?? defaultTimeRange

  const timeFrame: KpiCalculationTimeFrameDto | undefined = useMemo(() => {
    const now = moment().tz(timezone)
    const [startDate, endDate] = getPlantEntryPointQuickSelectFilter(timeRangeParam, now)

    const calculationTimeFrameType = QuickSelectSlotsToCalculationTimeFrameTypeMap[quickSlot]

    if (!calculationTimeFrameType) {
      throw new Error(`Invalid calculationTimeFrameType: ${calculationTimeFrameType}`)
    }

    return {
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
      calculationTimeFrameType: calculationTimeFrameType
    }
  }, [timezone, timeRangeParam, quickSlot])

  return {
    timeFrame,
    isLoading: false
  }
}
